
<button (click) = "Test()"></button>


<div class="col-md-12">
    <div class="card" style="border-radius: 0.5rem">
        <div class="card-header">
            <div class="card-title">Change Requests</div>
            <div class="card-category">View and Manage your change requests here</div>
        </div>
        <div class="card-body">
            <div><h2 class="b-b1 mb-0">
                You currently have <strong>{{pendingList.length}}</strong> pending requests
            </h2></div>
            <div class="row">
                <div class="col-md-12">
                    <div class="container-fluid my-4">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card border-info" style="border-radius: 0.5rem">
                                    <div class="d-flex justify-content-between card-header">
                                        <div class="card-title text-info">Pending Requests</div>
                                        <div class="card-title text-info">Date Requested</div>
                                    </div>
                                    <div class="card-body pb-0 scroll">
                                        <div *ngFor = "let request of pendingList">
                                            <div class="d-flex">

                                                <div *ngIf="request.Type=='Type'" class="flex-1 pt-1 ml-2">
                                                    <h4 class="fw-bold mb-0">{{GetRequesterName(request)}}'s Leave {{request.Type|uppercase}} change request</h4>
                                                    <p class = "mb-0">from <b>{{request.PreviousValue}}</b> to <b>{{request.RequestedValue}}</b> for <b>{{request.Date | date: 'mediumDate'}}</b></p>
                                                    <h5 class = "mb-0"> <i>" {{request.Comments}} "</i></h5>
                                                </div>

                                                <div *ngIf="request.Type=='Time'" class="flex-1 pt-1 ml-2">
                                                    <h4 class="fw-bold mb-0">{{GetRequesterName(request)}}'s workhours change request</h4>
                                                    <p class = "mb-0">from <b>{{request.PreviousValue}}</b> to <b>{{request.RequestedValue}}</b> for <b>{{request.Date | date: 'mediumDate'}}</b></p>
                                                    <h5 class = "mb-0"> <b>Reason:</b><i>" {{request.Comments}} "</i></h5>
                                                </div>

                                                <div class="d-flex align-items-center">
                                                    <h3 class="fw-bold text-info">{{request.DateRequested | date: 'mediumDate'}}</h3>
                                                </div>
                                            </div>
                                            <div class="row mb-0">
                                                <div class = "d-flex ml-auto mb-0">
                                                  <button type = "button"
                                                      class = "btn btn-outline-danger mr-1 btn-md border-0"
                                                      (click) = "DenyRequest(request)"
                                                      data-toggle="tooltip" placement="top"
                                                      ngbTooltip="Deny this Request">
                                                      <i class="fas fa-times"></i>
                                                  </button>
                                                  <button type = "button"
                                                      class = "btn btn-outline-success mr-1 btn-md border-0"
                                                      (click) = "AcceptRequest(request)"
                                                      data-toggle="tooltip" placement="top"
                                                      ngbTooltip="Accept this request">
                                                      <i class="fas fa-check"></i>
                                                  </button>
                                                </div>

                                            </div>
                                            <div class="separator-dashed"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card border-success" style="border-radius: 0.5rem">
                                    <div class="d-flex justify-content-between card-header">
                                        <div class="card-title text-success">Accepted Requests</div>
                                        <div class="card-title text-success">Date Accepted</div>
                                    </div>
                                    <div class="card-body pb-0 scroll">
                                        <div *ngFor = "let request of acceptedList">
                                            <div class="d-flex">

                                              <div *ngIf="request.Type=='Type'" class="flex-1 pt-1 ml-2">
                                                  <h4 class="fw-bold mb-0">{{GetRequesterName(request)}}'s Leave {{request.Type|uppercase}} change request</h4>
                                                  <p class = "mb-0">from <b>{{request.PreviousValue}}</b> to <b>{{request.RequestedValue}}</b> for <b>{{request.Date | date: 'mediumDate'}}</b></p>
                                                  <h5 class = "mb-0"> <i>" {{request.Comments}} "</i></h5>
                                                  <h5 class = "mb-0 text-muted">This request was approved by <b>{{GetAdminName(request)}}</b></h5>
                                              </div>

                                              <div *ngIf="request.Type=='Time'" class="flex-1 pt-1 ml-2">
                                                  <h4 class="fw-bold mb-0">{{GetRequesterName(request)}}'s workhours change request</h4>
                                                  <p class = "mb-0">from <b>{{request.PreviousValue}}</b> to <b>{{request.RequestedValue}}</b> for <b>{{request.Date | date: 'mediumDate'}}</b></p>
                                                  <h5 class = "mb-0"> <b>Reason:</b><i>" {{request.Comments}} "</i></h5>
                                                  <h5 class = "mb-0 text-muted">This request was approved by <b>{{GetAdminName(request)}}</b></h5>
                                              </div>

                                              <div class="d-flex ml-auto align-items-center">
                                                  <h3 class="fw-bold text-success">{{request.DateReviewed | date: 'mediumDate'}}</h3>
                                              </div>

                                            </div>
                                            <div class="separator-dashed"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card border-danger" style="border-radius: 0.5rem">
                                    <div class="d-flex justify-content-between card-header">
                                        <div class="card-title text-danger">Denied Requests</div>
                                        <div class="card-title text-danger">Date Denied</div>
                                    </div>
                                    <div class="card-body pb-0 scroll">
                                        <div *ngFor = "let request of rejectedList">
                                            <div class="d-flex">

                                              <div *ngIf="request.Type=='Type'" class="flex-1 pt-1 ml-2">
                                                  <h4 class="fw-bold mb-0">{{GetRequesterName(request)}}'s Leave {{request.Type|uppercase}} change request</h4>
                                                  <p class = "mb-0">from <b>{{request.PreviousValue}}</b> to <b>{{request.RequestedValue}}</b> for <b>{{request.Date | date: 'mediumDate'}}</b></p>
                                                  <h5 class = "mb-0"> <i>" {{request.Comments}} "</i></h5>
                                                  <h5 class = "mb-0 text-muted">This request was denied by <b>{{GetAdminName(request)}}</b></h5>
                                              </div>

                                              <div *ngIf="request.Type=='Time'" class="flex-1 pt-1 ml-2">
                                                  <h4 class="fw-bold mb-0">{{GetRequesterName(request)}}'s workhours change request</h4>
                                                  <p class = "mb-0">from <b>{{request.PreviousValue}}</b> to <b>{{request.RequestedValue}}</b> for <b>{{request.Date | date: 'mediumDate'}}</b></p>
                                                  <h5 class = "mb-0"> <b>Reason:</b><i>" {{request.Comments}} "</i></h5>
                                                  <h5 class = "mb-0 text-muted">This request was denied by <b>{{GetAdminName(request)}}</b></h5>
                                              </div>

                                              <div class="d-flex ml-auto align-items-center">
                                                  <h3 class="fw-bold text-danger">{{request.DateReviewed | date: 'mediumDate'}}</h3>
                                              </div>

                                            </div>
                                            <div class="separator-dashed"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
